import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Instagram } from "lucide-react";
import { Reveal } from "./Services";

export default function Studio() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="estudio" ref={ref} className="overflow-hidden py-20 sm:py-32 lg:py-40" data-testid="studio-section">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-14 px-6 sm:px-12 lg:grid-cols-2 lg:gap-20 lg:px-20">
        <Reveal>
          <div className="overflow-hidden rounded-3xl border border-line bg-paper3">
            <motion.img
              style={{ y, scale: 1.15 }}
              src="https://images.unsplash.com/photo-1648994517762-15aae4c01ce7?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Processo criativo do estúdio Essenza"
              loading="lazy"
              className="h-[380px] w-full object-cover sm:h-[480px]"
              data-testid="studio-image"
            />
          </div>
        </Reveal>
        <div>
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink-3">03 — Estúdio</p>
            <h2 className="mt-6 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
              Design essencial, com essência.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base leading-relaxed text-ink-2 sm:text-lg">
              A Essenza nasceu para tornar o bom design acessível: identidades visuais pensadas para pequenas marcas,
              criadores e negócios que querem parecer grandes sem gastar como grandes.
            </p>
            <p className="mt-4 text-base leading-relaxed text-ink-2 sm:text-lg">
              Cada pedido é tratado como único — do briefing aos arquivos finais, você fala direto com quem cria.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <a
              href="https://www.instagram.com/essenzaabr"
              target="_blank"
              rel="noreferrer"
              data-testid="studio-instagram-link"
              className="btn-lift mt-10 inline-flex items-center gap-3 rounded-full border border-ink px-8 py-4 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-ink hover:text-paper"
            >
              <Instagram className="h-4 w-4" /> Siga @essenzaabr
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
